/** @format */

import React from "react";
import { Box, ButtonBase } from "@mui/material";

const Suggestions = ({ items, onClick, disabled }) => {
  if (!items || items.length === 0) return null;
  return (
    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mt: 1.5 }}>
      {items.map((s, i) => (
        <ButtonBase
          key={i}
          onClick={() => onClick(s)}
          disabled={disabled}
          sx={{
            fontSize: 12,
            fontWeight: 500,
            px: 1.5,
            py: 0.75,
            borderRadius: "999px",
            border: "1px solid #e2e8f0",
            backgroundColor: "#fff",
            color: "#475569",
            transition: "all 150ms ease",
            "&:hover": {
              borderColor: "#a5b4fc",
              color: "#4338ca",
              backgroundColor: "#eef2ff",
            },
            "&.Mui-disabled": {
              opacity: 0.5,
              cursor: "not-allowed",
            },
          }}
        >
          <Box component="span" sx={{ color: "#94a3b8", mr: 0.75 }}>
            →
          </Box>
          {s.text}
        </ButtonBase>
      ))}
    </Box>
  );
};

export default Suggestions;
